import { render, staticRenderFns } from "./FactoryButtonsHotel.vue?vue&type=template&id=349fa782&scoped=true&"
import script from "./FactoryButtonsHotel.vue?vue&type=script&lang=ts&"
export * from "./FactoryButtonsHotel.vue?vue&type=script&lang=ts&"
import style0 from "./FactoryButtonsHotel.vue?vue&type=style&index=0&id=349fa782&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349fa782",
  null
  
)

export default component.exports